import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  quantityField: {
    width: '50%',
    margin: '10px 0'
  },
  quantityPadding: {
    paddingTop: '25px'
  },
  btns: {
    minWidth: '100%',
    display: "flex",
    marginLeft: '10px',
    height: 38,
  },
  snackbar: {
    position: "relative",
    paddingTop: "10px"
  },
}));

export default useStyles;
